import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRoles,
  getRoleById,
  createRole,
  updateRole,
  deleteRole,
  fetchRolePermissions,
  createModule,
  fetchDepartments
} from "./roleThunk";

const initialState = {
  roles: [],
  role: null,
  loading: false,
  error: null,
  successMessage: null,
  modules: [],
  rolePermissions: [],
  departments: [],
  roleDetails: [],
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    clearRoleState: (state) => {
      state.error = null;
      state.successMessage = null;
    },

    resetRoleForm: (state) => {
      state.role = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // ===============================
      // Fetch Roles
      // ===============================
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload;
      })

      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // ===============================
      // Fetch Departments
      // ===============================
      .addCase(fetchDepartments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.loading = false;
        state.departments = action.payload;
      })

      .addCase(fetchDepartments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ===============================
      // Get Role By ID
      // ===============================
      .addCase(getRoleById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getRoleById.fulfilled, (state, action) => {
        state.loading = false;
        state.role = action.payload;
      })

      .addCase(getRoleById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ===============================
      // Create Role
      // ===============================
      .addCase(createRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(createRole.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message || "Role created successfully";
      })

      .addCase(createRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ===============================
      // Update Role
      // ===============================
      .addCase(updateRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(updateRole.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message || "Role updated successfully";
      })

      .addCase(updateRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ===============================
      // Delete Role
      // ===============================
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(deleteRole.fulfilled, (state, action) => {
        state.loading = false;

        const deletedId = action.payload.id;

        state.roles = state.roles.filter(
          (role) => role._id !== deletedId
        );

        state.successMessage =
          action.payload.message || "Role deleted successfully";
      })

      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchRolePermissions.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchRolePermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.modules = action.payload.modules;
        state.rolePermissions = action.payload.rolePermissions;
        state.roleDetails = action.payload.roleDetails;
      })

      .addCase(fetchRolePermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createModule.pending, (state) => {
        state.loading = true;
      })

      .addCase(createModule.fulfilled, (state, action) => {
        state.loading = false;

        state.modules.push(action.payload.module);

        state.successMessage = action.payload.message;
      })

      .addCase(createModule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
      
  },
});

export const { clearRoleState, resetRoleForm } = roleSlice.actions;

export default roleSlice.reducer;